<div class="sentiment-overview-widget">
  <h3 class="sentiment-overview-widget__title">Sentiment Overview</h3>

  <div class="sentiment-overview-widget__columns">
    <!-- Left: primary rating (NPS/CSAT) + optional rating distribution donut -->
    <div class="sentiment-overview-widget__column">
      <div class="sentiment-overview-widget__score-card">
        <div class="sentiment-overview-widget__score-label">{{ primaryRatingLabel }}</div>
        <div
          class="sentiment-overview-widget__score-value"
          [class.sentiment-overview-widget__score-value--green]="primaryRatingGreen"
          [class.sentiment-overview-widget__score-value--amber]="primaryRatingAmber"
          [class.sentiment-overview-widget__score-value--red]="primaryRatingRed"
        >
          {{ primaryRatingValue | number: primaryRatingDigits }}
        </div>
        <div class="sentiment-overview-widget__score-hint">{{ primaryRatingHint }}</div>
      </div>

      <div class="sentiment-overview-widget__chart-block" *ngIf="showRatingDonutColumn">
        <h4 class="sentiment-overview-widget__chart-block-title">{{ ratingDonutTitle }}</h4>
        <div class="sentiment-overview-widget__chart-block-inner">
          <div class="sentiment-overview-widget__donut-wrap" *ngIf="getRatingDonutChartData(); else noRatingDonut">
            <svg class="sentiment-overview-widget__donut-svg" viewBox="0 0 120 120">
              <circle cx="60" cy="60" r="50" fill="none" stroke="#10B981" stroke-width="16"
                [attr.stroke-dasharray]="ratingDonutData.seg0.dashArray"
                [attr.stroke-dashoffset]="ratingDonutData.seg0.offset"
                stroke-linecap="round" transform="rotate(-90 60 60)"></circle>
              <circle cx="60" cy="60" r="50" fill="none" stroke="#F59E0B" stroke-width="16"
                [attr.stroke-dasharray]="ratingDonutData.seg1.dashArray"
                [attr.stroke-dashoffset]="ratingDonutData.seg1.offset"
                stroke-linecap="round" transform="rotate(-90 60 60)"></circle>
              <circle cx="60" cy="60" r="50" fill="none" stroke="#F97316" stroke-width="16"
                [attr.stroke-dasharray]="ratingDonutData.seg2.dashArray"
                [attr.stroke-dashoffset]="ratingDonutData.seg2.offset"
                stroke-linecap="round" transform="rotate(-90 60 60)"></circle>
            </svg>
          </div>
          <ng-template #noRatingDonut>
            <div class="sentiment-overview-widget__donut-wrap">
              <svg class="sentiment-overview-widget__donut-svg" viewBox="0 0 120 120">
                <circle cx="60" cy="60" r="50" fill="none" stroke="#9CA3AF" stroke-width="16" stroke-dasharray="314.16 314.16" transform="rotate(-90 60 60)"></circle>
              </svg>
            </div>
          </ng-template>
          <div class="sentiment-overview-widget__legend" *ngIf="ratingOverview as ro">
            <div class="sentiment-overview-widget__legend-item" *ngFor="let seg of ro.segments; let i = index">
              <span
                class="sentiment-overview-widget__legend-dot"
                [class.sentiment-overview-widget__legend-dot--positive]="i === 0"
                [class.sentiment-overview-widget__legend-dot--neutral]="i === 1"
                [class.sentiment-overview-widget__legend-dot--negative]="i === 2"
              ></span>
              <div>
                <div class="sentiment-overview-widget__legend-name">{{ seg.label }}</div>
                <div class="sentiment-overview-widget__legend-count">{{ seg.count | number }} feedback ({{ seg.percentage | number:'1.0-1' }}%)</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Right: Sentiment Score + Sentiment split donut -->
    <div class="sentiment-overview-widget__column">
      <div class="sentiment-overview-widget__score-card">
        <div class="sentiment-overview-widget__score-label">Sentiment Score</div>
        <div
          class="sentiment-overview-widget__score-value"
          [class.sentiment-overview-widget__score-value--green]="sentimentScore >= 0"
          [class.sentiment-overview-widget__score-value--red]="sentimentScore < 0"
        >
          {{ sentimentScore }}
        </div>
        <div class="sentiment-overview-widget__score-hint">% positive − % negative</div>
      </div>

      <div class="sentiment-overview-widget__chart-block">
        <h4 class="sentiment-overview-widget__chart-block-title">Sentiment split</h4>
        <div class="sentiment-overview-widget__chart-block-inner">
          <div class="sentiment-overview-widget__donut-wrap" *ngIf="getDonutChartData(); else noDonut">
            <svg class="sentiment-overview-widget__donut-svg" viewBox="0 0 120 120">
              <circle cx="60" cy="60" r="50" fill="none" stroke="#10B981" stroke-width="16"
                [attr.stroke-dasharray]="donutData.positive.dashArray"
                [attr.stroke-dashoffset]="donutData.positive.offset"
                stroke-linecap="round" transform="rotate(-90 60 60)"></circle>
              <circle cx="60" cy="60" r="50" fill="none" stroke="#F59E0B" stroke-width="16"
                [attr.stroke-dasharray]="donutData.neutral.dashArray"
                [attr.stroke-dashoffset]="donutData.neutral.offset"
                stroke-linecap="round" transform="rotate(-90 60 60)"></circle>
              <circle cx="60" cy="60" r="50" fill="none" stroke="#F97316" stroke-width="16"
                [attr.stroke-dasharray]="donutData.negative.dashArray"
                [attr.stroke-dashoffset]="donutData.negative.offset"
                stroke-linecap="round" transform="rotate(-90 60 60)"></circle>
            </svg>
          </div>
          <ng-template #noDonut>
            <div class="sentiment-overview-widget__donut-wrap">
              <svg class="sentiment-overview-widget__donut-svg" viewBox="0 0 120 120">
                <circle cx="60" cy="60" r="50" fill="none" stroke="#9CA3AF" stroke-width="16" stroke-dasharray="314.16 314.16" transform="rotate(-90 60 60)"></circle>
              </svg>
            </div>
          </ng-template>
          <div class="sentiment-overview-widget__legend">
            <div class="sentiment-overview-widget__legend-item">
              <span class="sentiment-overview-widget__legend-dot sentiment-overview-widget__legend-dot--positive"></span>
              <div>
                <div class="sentiment-overview-widget__legend-name">Positive</div>
                <div class="sentiment-overview-widget__legend-count">{{ sentiment.positive.count | number }} feedback ({{ sentiment.positive.percentage | number:'1.0-1' }}%)</div>
              </div>
            </div>
            <div class="sentiment-overview-widget__legend-item">
              <span class="sentiment-overview-widget__legend-dot sentiment-overview-widget__legend-dot--neutral"></span>
              <div>
                <div class="sentiment-overview-widget__legend-name">Neutral</div>
                <div class="sentiment-overview-widget__legend-count">{{ sentiment.neutral.count | number }} feedback ({{ sentiment.neutral.percentage | number:'1.0-1' }}%)</div>
              </div>
            </div>
            <div class="sentiment-overview-widget__legend-item">
              <span class="sentiment-overview-widget__legend-dot sentiment-overview-widget__legend-dot--negative"></span>
              <div>
                <div class="sentiment-overview-widget__legend-name">Negative</div>
                <div class="sentiment-overview-widget__legend-count">{{ sentiment.negative.count | number }} feedback ({{ sentiment.negative.percentage | number:'1.0-1' }}%)</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
